// src/api/admin.js
import request from '@/utils/request';

// 检查是否为管理员
export const checkAdmin = () => {
  return request({
    url: '/admin/check',
    method: 'get'
  });
};

// 获取文章列表（管理）
export const getArticleList = (params) => {
  return request({
    url: '/admin/articles',
    method: 'get',
    params
  });
};

// 获取单篇文章（管理编辑用）
export const getArticle = (id) => {
  return request({
    url: `/admin/article/${id}`,
    method: 'get'
  });
};

// 创建文章
export const createArticle = (data) => {
  return request({
    url: '/admin/article',
    method: 'post',
    data
  });
};

// 更新文章
export const updateArticle = (id, data) => {
  return request({
    url: `/admin/article/${id}`,
    method: 'put',
    data
  });
};

// 删除文章
export const deleteArticle = (id) => {
  return request({
    url: `/admin/article/${id}`,
    method: 'delete'
  });
};
